import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useSeasonsLogic from "./useSeasonsLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "Name", label: "Name", allowSorting: true },
  {
    field: "branch",
    label: "Branch",
    allowSorting: true,
    subvalue: "Name",
    showInFilter: true,
  },
  {
    field: "start_date",
    label: "Start date",
    allowSorting: true,
    showInFilter: true,
    isDate: true,
    // for csv export
    branchCode: "branch.code",
    //
  },
  {
    field: "end_date",
    label: "End date",
    allowSorting: true,
    showInFilter: true,
    isDate: true,
    // for csv export
    branchCode: "branch.code",
    //
  },
];

const SeasonPage = () => {
  const { apiRoute, addRoles, editRoles, deleteRoles, initFields } =
    useSeasonsLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];
      // Replace with your API endpoint to fetch the data
      await fetchDataAndMapToField(
        config,
        "branches",
        "branch",
        temp,
        "Name",
        undefined,
        undefined,
        "code"
      );

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Seasons." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"season"}
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        hasImport={true}
        importConfig={{
          relationshipMappings: [
            { field: "branch", lookupTable: "branch", lookupField: "Name" }
          ]
        }}
        enhancedTable={true}
      />
    </div>
  );
};

export default SeasonPage;
